<div class="base-knowledge">
    <div class="select-category">
        <div class="select-category__select">
            <span class="select-category__select-label">{{ 'BASEKNOWLEDGECATALOG.CATEGORY' | translate }}</span>
            <bzg-select placeholder="Select category" [(value)]="selectedCategory"
                (valueChange)="onCategoryChange($event)">
                <bzg-option [value]="allCategory">{{ 'BASEKNOWLEDGECATALOG.ALL' | translate }}</bzg-option>
                <bzg-option *ngFor="let category of categoryList" [value]="category">
                    {{ category.DisplayName }}</bzg-option>
            </bzg-select>
        </div>
        <bzg-search [placeholder]="'BASEKNOWLEDGECATALOG.SEARCH' | translate" (valueChange)="onSearch($event)"
            [fieldText]="inputSearch" (keydown.enter)="onEnterSearch()"></bzg-search>
    </div>

    <div class="category-container" *ngFor="let category of filteredCategoryList">
        <div class="category-container__header" (click)="toggleCategory(category)">
            <bzg-icon [nameIcon]="category.Expanded ? 'icon-arrow-down-black' : 'icon-arrow-right-black'" [size]="14"></bzg-icon>
            <span>{{ category.DisplayName }}</span>
        </div>
        <div *ngIf="category.Expanded">
            <div *ngFor="let catalog of category.KBCatalogs">
                <div class="category-container__catalog" (click)="toggleCatalog(catalog)">
                    <bzg-icon [nameIcon]="catalog.Expanded ? 'icon-arrow-down-black' : 'icon-arrow-right-black'" [size]="14"></bzg-icon>
                    <span class="category-container__catalog-title">{{ catalog.DisplayName }}</span>
                </div>
                <table *ngIf="catalog.Expanded && catalog.KBArtifacts.length > 0" class="category-container__table">
                    <thead>
                        <tr>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.NAME' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.FILE' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.DESCRIPTION' | translate }}</th>
                            <th>{{ 'BASEKNOWLEDGECATALOG.TABLE.STATUS' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let artifact of catalog.KBArtifacts">
                            <td title="{{ artifact.DisplayName }}">{{ artifact.DisplayName }}</td>
                            <td>
                                <div class="category-container__table-file">
                                    <bzg-icon [nameIcon]="'icon-file-color'"></bzg-icon>
                                    <span title="{{ artifact.FileName }}">{{ artifact.FileName }}</span>
                                </div>
                            </td>
                            <td title="{{ artifact.Description }}">{{ artifact.Description }}</td>
                            <td>
                                <div class="status" title="{{ artifact.ArtifactStatusLocalized }}">
                                    <span class="status-dot" [ngClass]="{
                                        'available': artifact.ArtifactStatus === Available,
                                        'processing': artifact.ArtifactStatus === Processing,
                                        'failed': artifact.ArtifactStatus === Failed,
                                        'to-process': artifact.ArtifactStatus === ToProcess,
                                        'unknown': artifact.ArtifactStatus === Unknown}">
                                        </span>
                                        {{ artifact.ArtifactStatusLocalized }}
                                </div>                                                
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div *ngIf="catalog.Expanded && catalog.KBArtifacts.length === 0"
                    class="category-container__no-artifacts">{{ 'BASEKNOWLEDGECATALOG.NO_ARTIFACTS' | translate }}</div>
            </div>
        </div>
    </div>
</div>